// extracted by mini-css-extract-plugin
export default {"card":"assessment-configuration_card__22L9o","chips":"assessment-configuration_chips__m6x2F"};